
import { CloudUpload as CloudUploadIcon, MenuBook as MenuBookIcon, Person as PersonIcon } from '@mui/icons-material'
import { Box, Breadcrumbs, Button, Container, Grid, LinearProgress, Link, List, ListItem, ListItemIcon, ListItemText, TextField, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import withStyles from '@mui/styles/withStyles'
import React from 'react'
import { Route, Link as RouterLink, Switch, useParams, useRouteMatch, withRouter } from "react-router-dom"
import SharedUtilities from '../../../shared/classes/SharedUtilities'
import Utilities from '../../classes/Utilities'
import { FormDialog, Heading } from '../../components'
import { withAppContext } from '../../context/AppContextProvider'

const styles = (theme) => ({
    loading: {
        marginTop: theme.spacing(2),
    },
    marginAbove: {
        marginTop: theme.spacing(2),
    },
    breadcrumbs: {
        marginTop: theme.spacing(2),
    },
    box: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    sumListItemText: {
        flex: 'none',
    },
})

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
})

class Patients extends React.Component {
    state = {
        waits: 1,
        patients: [],
        program: null,
        uploadDocument: {
            patient: null,
            file: null,
        },
    }

    async componentDidMount() {
        await this.getPatients()

        this.setState({
            waits: this.state.waits - 1,
        })
    }

    getPatients = async () => {
        await this.setState({
            waits: this.state.waits + 1,
        })

        try {
            const { leads, customers, program } = await this.props.socket.send('patients', {
                step: 'getPatients',
            })

            await this.setState({
                patients: [ ...leads, ...customers ],
                program,
            })

        } catch (err) {
            this.props.showError(err)
        }

        await this.setState({
            waits: this.state.waits - 1,
        })
    }

    handleDocumentFileChosen = async (patient, fileRef) => {
        try {
            const { features } = this.props

            if (fileRef.current.files[0].size > features.max_doc_upload_size) {
                const fileSizeKB = (fileRef.current.files[0].size / 1024).toFixed(2)
                const maxSizeKB = (features.max_doc_upload_size / 1024).toFixed(2)
                throw new Error(`File too large (${fileSizeKB} KB of maximum ${maxSizeKB} KB)`)
            }

            this.setState({
                uploadDocument: {
                    patient,
                    file: fileRef.current.files[0],
                },
            })

        } catch (err) {
            this.props.showError(err)
        }
    }

    handleDocumentCancel = async () => {
        this.setState({
            uploadDocument: {
                patient: null,
                file: null,
            },
        })
    }

    handleDocumentFileUpload = async (event) => {
        event.preventDefault()

        try {
            const { uploadDocument } = this.state
            const formData = Utilities.getFormValues(event.target)
            const base64file = await SharedUtilities.base64EncodeFile(uploadDocument.file)

            await this.setState({
                waits: this.state.waits + 1,
            })

            const response = await this.props.socket.send('patients', {
                step: 'uploadPatientDocument',
                patientId: uploadDocument.patient.id,
                patientType: uploadDocument.patient.type,
                base64file,
                filename: uploadDocument.file.name,
                name: formData.name,
                description: formData.description,
            })

            this.props.showMessage('Document Uploaded')

            this.setState({
                uploadDocument: {
                    patient: null,
                    file: null,
                },
            })

        } catch (err) {
            this.props.showError(err)
        }

        await this.setState({
            waits: this.state.waits - 1,
        })
    }

    render() {
        const { classes, history, match } = this.props
        const { patients, program, waits, uploadDocument } = this.state
        const url = match.path

        return (
            <Container maxWidth="sm">
                <Heading icon={<MenuBookIcon />}>
                    My Patients
                </Heading>
                <Grid container justifyContent="space-between" alignItems="flex-end">
                    <Grid className={classes.breadcrumbs} item xs={12} sm={7} md={9} lg={9}>
                        <Switch>
                            <Route path={`${url}`} exact>
                                <Breadcrumbs aria-label="breadcrumb">
                                    <Link component={RouterLink} to={`${url}`} color="textPrimary" underline="hover">
                                        Patients
                                    </Link>
                                </Breadcrumbs>
                            </Route>
                            <Route path={`${url}/patient-:patientId`}>
                                <Breadcrumbs aria-label="breadcrumb">
                                    <Link component={RouterLink} to={`${url}`} color="inherit" underline="hover">
                                        Patients
                                    </Link>
                                    {waits == 0 &&
                                        <SelectedPatientLink />
                                    }
                                </Breadcrumbs>
                            </Route>
                        </Switch>
                    </Grid>
                </Grid>
                {waits > 0 &&
                    <LinearProgress className={classes.loading} />
                }
                {waits == 0 &&
                    <Switch>
                        <Route path={`${url}/`} exact>
                            <List>
                                <PatientList
                                    classes={classes}
                                    patients={patients}
                                    program={program}
                                    onPatientselect={(patientId) => {
                                        history.push(`${url}/patient-${patientId}`)
                                    }}
                                />
                            </List>
                        </Route>
                        <Route path={`${url}/patient-:patientId`}>
                            <PatientContents
                                classes={classes}
                                patients={patients}
                                handleFileChosen={this.handleDocumentFileChosen}
                            />
                        </Route>
                    </Switch>
                }
                <FormDialog
                    open={!!uploadDocument.file}
                    onSubmit={this.handleDocumentFileUpload}
                    onCancel={this.handleDocumentCancel}
                    title="Document Details"
                    submitText="Upload"
                >
                    <TextField
                        variant="standard"
                        id="name"
                        name="name"
                        label="Name"
                        autoComplete="name"
                        required
                        fullWidth
                    />
                    <TextField
                        variant="standard"
                        id="name"
                        name="description"
                        label="Description"
                        autoComplete="name"
                        required
                        fullWidth
                    />
                </FormDialog>
            </Container>
        )
    }
}

export default withAppContext(withRouter(withStyles(styles, { withTheme: true })(Patients)))

function SelectedPatientLink(props) {
    const { url } = useRouteMatch()
    const { patientId } = useParams()

    return (
        <Link component={RouterLink} to={`${url}`} color="textPrimary" underline="hover">
            Patient # {patientId}
        </Link>
    )
}

function PatientList(props) {
    const { patients, program } = props

    if (!patients.length) {
        return (
            <Box>
                <Typography>You have no patients.</Typography>
            </Box>
        )
    }

    return patients.map(patient => {
        let patientSecondaryText = patient.type

        if (program == 'MDVIP') {
            patientSecondaryText = patient.type == 'Customer' ? 'IP Protocol Underway' : 'Referred'
        }

        return (
            <ListItem key={`${patient.type}-${patient.id}`} button onClick={props.handlePatientClick}>
                <ListItemIcon>
                    <PersonIcon />
                </ListItemIcon>
                <ListItemText
                    primary={patient.full_name}
                    secondary={patientSecondaryText}
                    onClick={() => { props.onPatientselect(patient.id) }}
                />
            </ListItem>
        )
    })
}

function PatientContents(props) {
    const { patientId } = useParams()
    const { classes, patients, handleFileChosen } = props
    const fileRef = React.createRef()
    const patient = patients.find(patient => patient.id == patientId)

    return (
        <Box className={classes.box}>
            <Typography className={classes.marginAbove}>
                Name: {patient.full_name}
            </Typography>
            <Typography>
                Email: <a href={`mailto:${patient.email_address}`}>{patient.email_address}</a>
            </Typography>
            <Button
                className={classes.marginAbove}
                component="label"
                role={undefined}
                variant="contained"
                tabIndex={-1}
                startIcon={<CloudUploadIcon />}
                fullWidth
            >
                Upload Document
                <VisuallyHiddenInput
                    ref={fileRef}
                    type="file"
                    onInput={() => { handleFileChosen(patient, fileRef) }}
                />
            </Button>
        </Box>
    )
}
